export * from "./getOptimizedBackgroundImage";
